import { render, staticRenderFns } from "./PartnerOrganization.vue?vue&type=template&id=3a4c0456"
import script from "./PartnerOrganization.vue?vue&type=script&lang=js"
export * from "./PartnerOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports